import { render, staticRenderFns } from "./WidgetInfoButton.vue?vue&type=template&id=45d8868e&scoped=true"
import script from "./WidgetInfoButton.vue?vue&type=script&lang=js"
export * from "./WidgetInfoButton.vue?vue&type=script&lang=js"
import style0 from "./WidgetInfoButton.vue?vue&type=style&index=0&id=45d8868e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45d8868e",
  null
  
)

export default component.exports